import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (e) {
      setError(e?.response?.data?.detail || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F8F5F0] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <Lock className="text-[#C9A96E] mx-auto mb-4" size={28} strokeWidth={1.4} />
          <div className="overline text-[#C9A96E] mb-3">Admin</div>
          <h1 className="font-serif text-4xl">My Private Shopper</h1>
        </div>

        <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
          <label className="block">
            <span className="overline text-[#F8F5F0]/70 block mb-2">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full px-4 py-3 bg-transparent border border-[#C9A96E]/30 text-[#F8F5F0] focus:outline-none focus:border-[#C9A96E]"
            />
          </label>
          <label className="block">
            <span className="overline text-[#F8F5F0]/70 block mb-2">Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full px-4 py-3 bg-transparent border border-[#C9A96E]/30 text-[#F8F5F0] focus:outline-none focus:border-[#C9A96E]"
            />
          </label>

          {error && (
            <div data-testid="admin-login-error" className="text-sm text-[#C9A96E] px-4 py-2 border-l-2 border-[#C9A96E]">
              {String(error)}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#C9A96E] text-[#0A0A0A] text-sm uppercase tracking-[0.18em] hover:bg-[#A68A52] disabled:opacity-60"
          >
            {loading && <Loader2 className="animate-spin" size={16} />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
